module.exports = __webpack_public_path__ + "img/img_market.fefdbd2b.png";